import React from 'react';

const AboutPage = () => {
    return (
        <div>
            <h1>About Page</h1>
            <p>Learn about Little Lemon.</p>
        </div>
    );
};

export default AboutPage;